import axios from "axios";
import { toast } from "react-toastify";

export const setupAxiosInterceptors = (logout) => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        toast.warn("פג תוקף ההתחברות. אנא התחבר/י שוב.");

        // הפעלת הפונקציה מה־AuthContext
        logout();

        // הפניה למסך ההתחברות לאחר שנייה
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      }

      return Promise.reject(error);
    }
  );
};
